import axios from "axios";
import Constant from "../utils/constant";

const Register = (firstName, lastName, mobileNo, emailId) => {
  return axios
    .post(Constant.BASE_URL + "pos/register", {
      firstName,
      lastName,
      mobileNo,
      emailId,
    })
    .then((response) => {
      if (response.data.data) {
        localStorage.setItem("user", JSON.stringify(response.data.data));
        return response;
      } else {
        alert(response.data.message);
      }
      return response;
    })
    .catch((e) => {});
};

const otp = (phone, email, otp) => {
  return axios
    .patch(Constant.BASE_URL + "pos/verifyOtp", {
      mobileNo: phone,
      emailId: email,
      otp: otp,
    })
    .then((response) => {
      if (response.data.data) {
        alert(response.data.message);
        return response.data.status;
      } else {
        alert(response.data.message);
        return response.data.status;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

const resendOtp = async (firstName, phone, email) => {
  try {
    const response = await axios.patch(Constant.BASE_URL + "pos/resendOtp", {
      firstName: firstName,
      mobileNo: phone,
      emailId: email,
    });
    if (response.data.data) {
      alert(response.data.message);
    } else {
      alert(response.data.message);
    }
    return response.data.data;
  } catch (e) {
    console.error(e);
  }
};

const login = async (username, password) => {
  const response = await axios.post(Constant.BASE_URL + "admin/login", {
    emailId: username,
    password,
  });
  if (response.data.data) {
    localStorage.setItem("user", JSON.stringify(response.data.data));
  } else {
    alert(response.data.message);
  }
  return response.data.data;
};

const SuperAdminLogin = async (email, password, role) => {
  const response = await axios.post(
    Constant.BASE_URL + "admin/login",
    // "http://localhost:1051/hrms/admin/login",
    {
      email,
      password,
      role,
    }
  );
  if (response.data.data) {
    localStorage.setItem("superUser", JSON.stringify(response.data.data));
    return response.data.data;
  } else {
    alert(response.data.message);
  }
  return response.data.data;
};
// const EmployeeLogin = async (username, password, role) => {
//   const response = await axios.post(
//     // Constant.BASE_URL + "hrms/login",
//     "http://localhost:1051/hrms/login",
//     {
//       username,
//       password,
//       role,
//     }
//   );
//   if (response.data.data) {
//     localStorage.setItem("user", JSON.stringify(response.data.data));
//     return response.data.data;
//   } else {
//     alert(response.data.message);
//   }
//   return response.data.data;
// };
// const logout = () => {
//   localStorage.removeItem("user");
// };

// const EmployeeLogin = async (username, password, role) => {
//   try {
//     const response = await axios.post("http://localhost:1051/hrms/login", {
//       username,
//       password,
//       role,
//     });

//     // Save token/user info this
//     if (response.data.success) {
//       const userData = {
//         token: response.data.token,
//         role: response.data.role,
//         employeeRef: response.data.employeeRef,
//         username: username,
//       };
//       localStorage.setItem("user", JSON.stringify(userData));
//       return userData; // <- return this for navigation
//     } else {
//       alert(response.data.message);
//       return null;
//     }
//   } catch (error) {
//     console.error(error);
//     alert("Login failed. Please try again.");
//     return null;
//   }
// };
// src/services/auth.service.js

const EmployeeLogin = async (username, password, role) => {
  try {
    const response = await axios.post(
      // `http://localhost:1051/hrms/login`,
      Constant.BASE_URL + "hrms/login",

      {
        username,
        password,
        role,
      }
    );

    // Save token/user info
    if (response.data.success) {
      const userData = {
        token: response.data.token,
        role: response.data.role,
        employeeRef: response.data.employeeRef,
        username: username,
        id: response.data.userId, // Add user ID
        name: response.data.name, // Add user name
      };

      // Save to localStorage
      localStorage.setItem("authToken", response.data.token);
      localStorage.setItem("userRole", response.data.role);
      localStorage.setItem("userName", response.data.name);
      localStorage.setItem("userId", response.data.userId);
      localStorage.setItem("user", JSON.stringify(userData));

      return userData;
    } else {
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.error(error);
    alert("Login failed. Please try again.");
    return null;
  }
};

const requestPasswordOtp = async (email) => {
  try {
    const response = await axios.post(
      // "http://localhost:1051/hrms/" + "password/request-otp",
      Constant.BASE_URL + "hrms/password/request-otp",
      {
        email,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Request OTP error:", error.response?.data || error.message);
    throw error.response?.data || new Error("Failed to request OTP.");
  }
};

const verifyPasswordOtp = async (userId, otp) => {
  try {
    // Trim whitespace from OTP before sending
    const trimmedOtp = String(otp).trim(); // Ensure it's a string then trim
    const response = await axios.post(
      // "http://localhost:1051/hrms/" + "password/verify-otp",
      Constant.BASE_URL + "hrms/password/verify-otp",
      {
        userId,
        otp: trimmedOtp, // Use the trimmed OTP
      }
    );
    return response.data;
  } catch (error) {
    console.error("Verify OTP error:", error.response?.data || error.message);
    throw error.response?.data || new Error("Failed to verify OTP.");
  }
};

const resetPassword = async (resetToken, newPassword) => {
  try {
    const response = await axios.post(
      // "http://localhost:1051/hrms/" + "password/reset",
      Constant.BASE_URL + "hrms/password/reset",
      {
        resetToken,
        newPassword,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Reset Password error:",
      error.response?.data || error.message
    );
    throw error.response?.data || new Error("Failed to reset password.");
  }
};
const logout = () => {
  // Clear both POS and HRMS authentication data
  localStorage.removeItem("user");
  localStorage.removeItem("superUser");
};

export default {
  Register,
  login,
  otp,
  resendOtp,
  logout,
  SuperAdminLogin,
  EmployeeLogin,
  resetPassword,
  verifyPasswordOtp,
  requestPasswordOtp,
  // HRMS password reset APIs
  // requestHrmsPasswordOtp: async (email) => {
  //   const response = await axios.post(
  //     "http://localhost:1051/hrms/password/request-otp",
  //     { email }
  //   );
  //   return response.data;
  // },
  // verifyHrmsPasswordOtp: async (userId, otp) => {
  //   const response = await axios.post(
  //     "http://localhost:1051/hrms/password/verify-otp",
  //     { userId, otp }
  //   );
  //   return response.data;
  // },
  // resetHrmsPassword: async (resetToken, newPassword) => {
  //   const response = await axios.post(
  //     "http://localhost:1051/hrms/password/reset",
  //     { resetToken, newPassword }
  //   );
  //   return response.data;
  // },
};
